import type { FilterChip } from '@/components/filter-bar'
import type { ListarAdministradoresQuery, StatusAdministrador } from '@/types/administrador'
import { STATUS_ADMINISTRADOR } from '@/types/administrador'

export interface FiltroAdministradores {
  busca: string
  situacao: StatusAdministrador
}

export const filtroVazio: FiltroAdministradores = {
  busca: '',
  situacao: STATUS_ADMINISTRADOR.Todas,
}

const CAMPOS_PAINEL = ['situacao'] as const

const preenchido = (campo: keyof FiltroAdministradores, filtro: FiltroAdministradores): boolean =>
  campo === 'situacao'
    ? filtro.situacao !== STATUS_ADMINISTRADOR.Todas
    : filtro[campo].trim() !== ''

export const contarFiltrosDoPainel = (filtro: FiltroAdministradores): number =>
  CAMPOS_PAINEL.filter((campo) => preenchido(campo, filtro)).length

export const paraFiltroApi = (
  filtro: FiltroAdministradores,
  pageSize: number,
): ListarAdministradoresQuery => ({
  pageNumber: 1,
  pageSize,
  busca: filtro.busca || null,
  situacao: filtro.situacao,
})

const ROTULOS: Record<keyof FiltroAdministradores, string> = {
  busca: 'Busca',
  situacao: 'Situação',
}

const ROTULO_SITUACAO: Record<StatusAdministrador, string> = {
  [STATUS_ADMINISTRADOR.Todas]: 'Todos',
  [STATUS_ADMINISTRADOR.Ativas]: 'Ativos',
  [STATUS_ADMINISTRADOR.Inativas]: 'Inativos',
}

export const montarChips = (
  filtro: FiltroAdministradores,
  remover: (campo: keyof FiltroAdministradores) => void,
): FilterChip[] =>
  (['busca', ...CAMPOS_PAINEL] as (keyof FiltroAdministradores)[])
    .filter((campo) => preenchido(campo, filtro))
    .map((campo) => ({
      key: campo,
      label: ROTULOS[campo],
      value: campo === 'situacao' ? ROTULO_SITUACAO[filtro.situacao] : filtro[campo],
      onRemove: () => remover(campo),
    }))
